import { render, staticRenderFns } from "./apply_sss.vue?vue&type=template&id=0bc51e47&scoped=true"
import script from "./apply_sss.vue?vue&type=script&lang=js"
export * from "./apply_sss.vue?vue&type=script&lang=js"
import style0 from "./apply_sss.vue?vue&type=style&index=0&id=0bc51e47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc51e47",
  null
  
)

export default component.exports